import KpiItemCateEditorForm from '@/views/kpi/kpi-build/proj-kpi-item/cate-editor-form.vue';
import KpiItemEditorForm from '@/views/kpi/kpi-build/proj-kpi-item/kpi-item-editor-form.vue';
export const useProjKpiItemEditorModal = () => {
  const {
    openEditor
  } = useComponentModal();
  const showProjKpiCateEditorModal = async (title, {
    id = '',
    projId = '',
    parentId = ''
  } = {}) => {
    return await openEditor(title, KpiItemCateEditorForm, {
      id,
      projId,
      parentId
    }, {
      width: '50%',
      showMaximize: false,
      showMinimize: false
    });
  };
  const showProjKpiItemEditorModal = async (title, {
    id = '',
    projId = '',
    parentId = ''
  } = {}) => {
    return await openEditor(title, KpiItemEditorForm, {
      id,
      projId,
      parentId
    }, {
      width: '70%',
      showMaximize: false,
      showMinimize: false
    });
  };
  return {
    showProjKpiCateEditorModal,
    showProjKpiItemEditorModal
  };
};